import { schoolNowTime } from './schoolTime';

export const formatTime = (t) => {
  if (!t) return null;
  const [h, m] = t.split(':');
  const d = new Date();
  d.setHours(Number(h), Number(m), 0, 0);
  return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
};

const timingWindows = (batch) => {
  const windows = [[batch.startTime, batch.endTime]];
  if (batch.isFlexible) windows.push([batch.startTime2, batch.endTime2]);
  return windows.filter(([start, end]) => start && end);
};

export const formatTiming = (batch) => {
  const windows = timingWindows(batch);
  if (windows.length === 0) return null;
  return windows.map(([start, end]) => `${formatTime(start)} – ${formatTime(end)}`).join(' or ');
};

// The backend is still the source of truth (it re-checks this on submit),
// but this uses the same school-timezone clock so the button's on/off
// state here actually matches what the backend will allow — using the
// browser's own timezone would disagree whenever a device isn't set to
// the school's timezone. A flexible batch's two sessions are each their
// own window; either one being open is enough.
export const isWithinClassHours = (batch) => {
  const windows = timingWindows(batch);
  if (windows.length === 0) return true;
  const nowTime = schoolNowTime();
  return windows.some(([start, end]) => nowTime >= start && nowTime <= end);
};
